import React from "react";

/**
 * A hook that runs a callback on update.
 *
 * @param {Function} callback
 * @param {Array} deps
 */
function useDidUpdate(callback, deps = []) {
  const initalMount = React.useRef(true);
  // Only run code if the component was updated in any way.
  React.useEffect(() => {
    if (!initalMount.current) {
      return callback();
    }
    return () => {
      initalMount.current = false;
    };
  }, deps);
}

export default useDidUpdate;
